<template>
    <tr
        v-if="!isBeingEdited"
        class="kgr-table__row"
    >
        <td class="kgr-table__cell">
            {{ holidayDate }}
        </td>
        <td class="kgr-table__cell">
            {{ holiday.description }}
        </td>
        <td class="kgr-table__cell kgr-table__cell--actions">
            <button
                v-if="isEditable"
                type="button"
                class="kgr-table__action"
                @click="$emit('edit')"
            >
                <kgr-icon-edit :size="15" />
            </button>
            <button
                v-if="isDeletable"
                type="button"
                class="kgr-table__action"
                @click="$emit('remove')"
            >
                <kgr-icon-delete />
            </button>
        </td>
    </tr>
</template>

<script>
import IconDelete from '../../common/icon/IconDelete';
import IconEdit from '../../common/icon/IconEdit';
import KindergartenHoliday from '../../../js/dto/KindergartenHoliday';
import moment from 'moment';

export default {
    components: {
        'kgr-icon-edit': IconEdit,
        'kgr-icon-delete': IconDelete,
    },
    props: {
        holiday: {
            type: KindergartenHoliday,
            required: true,
        },
        editHolidays: {
            type: Array,
            required: true,
        },
        isEditable: {
            type: Boolean,
            required: true,
        },
        isDeletable: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        isBeingEdited() {
            return this.editHolidays.map((editHoliday) => editHoliday.id).indexOf(this.holiday.id) !== -1;
        },
        holidayDate() {
            return moment(this.holiday.date, 'YYYY-MM-DD').format('DD.MM.YYYY');
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
